// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\MathBoardPage.tsx

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";

export default function MathBoardPage() {
  const navigate = useNavigate();
  const { themeColors } = useContext(ThemeContext);

  const [problem, setProblem] = useState("");
  const [solution, setSolution] = useState<string[]>([]);

  function solveProblem() {
    try {
      const parts = problem
        .replace("×", "*")
        .replace("÷", "/")
        .split(/[\+\-\*\/]/);

      const operator = problem.match(/[\+\-\*\/×÷]/)?.[0];

      if (!operator || parts.length !== 2) {
        setSolution(["Please enter a simple math problem like 8 + 7"]);
        return;
      }

      const a = Number(parts[0]);
      const b = Number(parts[1]);

      if (isNaN(a) || isNaN(b)) {
        setSolution(["I couldn't understand those numbers."]);
        return;
      }

      let result = 0;
      let steps: string[] = [];

      if (operator === "+") {
        result = a + b;
        steps = [
          `Step 1: Start with ${a}`,
          `Step 2: Add ${b}`,
          `${a} + ${b} = ${result}`,
        ];
      }

      if (operator === "-") {
        result = a - b;
        steps = [
          `Step 1: Start with ${a}`,
          `Step 2: Subtract ${b}`,
          `${a} - ${b} = ${result}`,
        ];
      }

      if (operator === "*" || operator === "×") {
        result = a * b;
        steps = [
          `Step 1: Multiply ${a} by ${b}`,
          `${a} × ${b} = ${result}`,
        ];
      }

      if (operator === "/" || operator === "÷") {
        result = a / b;
        steps = [
          `Step 1: Divide ${a} by ${b}`,
          `${a} ÷ ${b} = ${result}`,
        ];
      }

      setSolution(steps);
    } catch {
      setSolution(["Something went wrong solving the problem."]);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px",
        background: themeColors.bg,
        color: themeColors.text,
      }}
    >
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <h1
          style={{
            fontSize: "48px",
            color: themeColors.accent,
            marginBottom: "10px",
          }}
        >
          Ava Math Board
        </h1>

        <p style={{ marginBottom: "30px", opacity: 0.8 }}>
          Enter a math problem and Ava will solve it step by step.
        </p>

        {/* Input */}
        <input
          value={problem}
          onChange={(e) => setProblem(e.target.value)}
          placeholder="Example: 48 + 27"
          style={{
            width: "100%",
            padding: "14px",
            fontSize: "18px",
            borderRadius: "10px",
            border: `1px solid ${themeColors.border}`,
            background: themeColors.panel,
            color: themeColors.text,
          }}
        />

        <button
          onClick={solveProblem}
          style={{
            marginTop: "16px",
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "10px",
            background: themeColors.buttonBg,
            color: themeColors.text,
            border: `1px solid ${themeColors.border}`,
            cursor: "pointer",
          }}
        >
          Solve
        </button>

        {/* Board */}
        <div
          style={{
            marginTop: "30px",
            padding: "30px",
            borderRadius: "14px",
            background: themeColors.cardBg,
            border: `1px solid ${themeColors.border}`,
            boxShadow: themeColors.glow,
          }}
        >
          {solution.map((step, i) => (
            <div
              key={i}
              style={{
                fontSize: "22px",
                marginBottom: "10px",
              }}
            >
              {step}
            </div>
          ))}
        </div>

        <div style={{ marginTop: "40px" }}>
          <button
            onClick={() => navigate("/education")}
            style={{
              border: `1px solid ${themeColors.border}`,
              background: themeColors.buttonBg,
              color: themeColors.text,
              borderRadius: "10px",
              padding: "12px 18px",
              cursor: "pointer",
            }}
          >
            Back to Education
          </button>
        </div>
      </div>
    </div>
  );
}